var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33333 11.3338H9.66667M6.34513 1.84315L1.82359 5.3599C1.52135 5.59498 1.37022 5.71252 1.26135 5.85973C1.16491 5.99012 1.09307 6.13701 1.04935 6.29319C1 6.4695 1 6.66095 1 7.04386V11.8671C1 12.6139 1 12.9872 1.14532 13.2725C1.27316 13.5233 1.47713 13.7273 1.72801 13.8552C2.01323 14.0005 2.3866 14.0005 3.13333 14.0005H10.8667C11.6134 14.0005 11.9868 14.0005 12.272 13.8552C12.5229 13.7273 12.7268 13.5233 12.8547 13.2725C13 12.9872 13 12.6139 13 11.8671V7.04386C13 6.66095 13 6.4695 12.9506 6.29319C12.9069 6.13701 12.8351 5.99012 12.7386 5.85973C12.6298 5.71252 12.4787 5.59499 12.1764 5.35991L7.65487 1.84315C7.42065 1.66099 7.30354 1.5699 7.17423 1.53489C7.06013 1.504 6.93987 1.504 6.82577 1.53489C6.69646 1.5699 6.57935 1.66099 6.34513 1.84315Z",
    stroke: "#3485FF",
    strokeWidth: 1.24444,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.65d6f26b8d5ed23ec4ddd9bab92d2d60.svg";
export { ForwardRef as ReactComponent };